import { useRedux } from "hooks-for-redux";

export const [useAuth, setAuth] = useRedux("auth", false);
export const [useName, setName] = useRedux("name", "");
export const [useRoles, setRoles] = useRedux("roles", []);
export const [useJar, setJar] = useRedux("jar", {});
export const [useToken, setToken] = useRedux("token", "");